import { SampleBoardRecipe } from "@app/strain/sample-boards/models/sample-board-recipe.model";
import {
    SampleBoardMeasurementInstructions
} from "@app/strain/sample-boards/models/documentation/sample-board-measurement-instructions.model";
import {
    SampleBoardConstructionInstructions
} from "@app/strain/sample-boards/models/documentation/sample-board-construction-instructions.model";
import {RegistryItemSampleBoard} from "@app/strain/materials/models/registry-item-sample-board";

// TODO Keep in mind that for the strain sample board image creation, we have a separate endpoint
//  and model StrainSaveMeasurementInstructionImages
export class SampleBoardDocumentation {
    recipe?: SampleBoardRecipe;
    constructionInstructions: SampleBoardConstructionInstructions | null; // The File
    measurementInstructions?: SampleBoardMeasurementInstructions; // Strain Report step 2
    registerItems?: RegistryItemSampleBoard[];

    constructor(entry: any = {}) {
        this.recipe = entry?.recipe ? new SampleBoardRecipe(entry.recipe) : null;
        this.constructionInstructions = entry?.constructionInstructions
            ? new SampleBoardConstructionInstructions(entry.constructionInstructions)
            : null;
        this.measurementInstructions = entry?.measurementInstructions
            ? new SampleBoardMeasurementInstructions(entry.measurementInstructions)
            : null;
        this.registerItems = entry?.registerItems
            ? entry.registerItems.map(item => new RegistryItemSampleBoard(item))
            : [];
    }
}



